import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import AboutSection from "@/components/AboutSection";
import TarotSection from "@/components/TarotSection";
import DeckSection from "@/components/DeckSection";
import SpreadsSection from "@/components/SpreadsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactSection from "@/components/ContactSection";
import EnergyHealingSection from "@/components/EnergyHealingSection";
import CardModal from "@/components/CardModal";
import SpreadModal from "@/components/SpreadModal";

function App() {
  const [activeCard, setActiveCard] = useState(null);
  const [activeSpread, setActiveSpread] = useState(null);

  return (
    <div className="App cosmic-bg">
      <Navbar />
      <main className="relative">
        <Hero />
        <AboutSection />
        <TarotSection />
        <DeckSection onCardClick={setActiveCard} />
        <SpreadsSection onSpreadClick={setActiveSpread} />
        <TestimonialsSection />
        <ContactSection />
        <EnergyHealingSection />
      </main>
      <Footer />

      <CardModal card={activeCard} onClose={() => setActiveCard(null)} />
      <SpreadModal spread={activeSpread} onClose={() => setActiveSpread(null)} />

      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(26, 30, 69, 0.95)",
            border: "1px solid rgba(255, 210, 74, 0.3)",
            color: "#F5F6FF",
          },
        }}
      />
    </div>
  );
}

export default App;
